import React from 'react';

import { flagStyles } from '../settings';

const SvgPH = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-4200px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgPH;
